var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.isGeneralComponent)?_c('div',[_c('basic-information-about-subject',{attrs:{"section":_vm.section}})],1):_c('div',[_c('subject-information-table',{attrs:{"section":_vm.section}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }